export function DemoBadge({ label = "Demo", className = "" }) {
  return (
    <span
      data-testid="demo-badge"
      className={`inline-flex items-center rounded-full border border-border bg-elevated px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-widest text-muted-foreground ${className}`}
    >
      {label}
    </span>
  );
}
